import { IResourceReference } from '../interfaces/resource-reference.interface';

export class ResourceReference implements IResourceReference {
  constructor(public reference: string,
              public resourceType: string) {

  }

}
